import {
    VIEW_DASHBOARD_PROGRESS,
    VIEW_DASHBOARD_COLLECTOR_PROGRESS,
    VIEW_DASHBOARD_LOCATION_PROGRESS,
    VIEW_DASHBOARD_QUALITY,
    VIEW_DASHBOARD_STATUS_FUNNEL,
    VIEW_DASHBOARD_MAP,
} from "../constant/ActionType";

// shop.js passes `null` through on a failed request (auth/network error) — track
// that as `error` so the UI can distinguish "still loading" / "empty" / "failed".
const createDashboardReducer = (actionType) => {
    return function dashboardReducer(state = { data: null, error: false }, action) {
        if (action.type === actionType) {
            if (!action.data) {
                return { ...state, error: true };
            }
            return { data: action.data.data, error: false };
        }
        return state;
    };
};

export const DashboardProgress_reducer = createDashboardReducer(VIEW_DASHBOARD_PROGRESS);
export const DashboardCollectorProgress_reducer = createDashboardReducer(VIEW_DASHBOARD_COLLECTOR_PROGRESS);
export const DashboardLocationProgress_reducer = createDashboardReducer(VIEW_DASHBOARD_LOCATION_PROGRESS);
export const DashboardQuality_reducer = createDashboardReducer(VIEW_DASHBOARD_QUALITY);
export const DashboardStatusFunnel_reducer = createDashboardReducer(VIEW_DASHBOARD_STATUS_FUNNEL);
export const DashboardMap_reducer = createDashboardReducer(VIEW_DASHBOARD_MAP);
